<template>
  <button
    class="btn btn-primary mr-3 print-button"
    @click="action"
    v-html="loading ? spin() : ic('download') + ' Export PDF'"
  />
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
  mixins: [helper],
  props: {
    loading: false,
    text: { default: "Pdf" },
    action: {
      type: Function,
      default: function () {
        return () => {};
      },
    },
  },
  methods: {},
};
</script>
<style>
@media print {
  .print-button {
    display: none;
  }
}
</style>